import RailsResource from './rails-resource';

class CourseService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'courses',
      ajaxLoader: false
    });
  }

  audienceStats() {
    return this.call(`${this.url}/${this.resource}/audience-stats`);
  }
}

export default new CourseService();